import React from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number | false;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`}>
      {value === index && children}
    </div>
  );
};

export default TabPanel;
